const getters = {
  sidebar: state => state.app.sidebar,
  name: state => state.user.name,
  permission_routes: state => state.permission.routes,
  breadArr: state => state.app.breadArr,
}
export default getters
